import React from 'react';
import { Trans } from 'react-i18next';
import styles from '../WhatsAppMessage.module.scss';
const WhatsAppOrderMessage = ({ order }) => {
    const { text, product_items = [] } = order;
    const totalPrice = product_items.reduce((total, item) => total + item.item_price * item.quantity, 0);
    const currency = product_items.length > 0 ? product_items[0].currency : '';
    return (React.createElement("div", null,
        React.createElement("strong", null,
            React.createElement(Trans, { i18nKey: "orderPlaced" })),
        text && React.createElement("div", { className: styles.orderText }, text),
        React.createElement("div", { className: styles.orderItemsList }, product_items.map((item, index) => (React.createElement("div", { key: index, className: styles.orderItem },
            React.createElement("span", null,
                item.quantity,
                "x ",
                item.product_retailer_id),
            React.createElement("span", null,
                (item.item_price * item.quantity).toFixed(2),
                " ",
                currency))))),
        product_items.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement("hr", null),
            React.createElement("div", { className: styles.orderTotal },
                React.createElement("span", null, "Total"),
                React.createElement("span", null,
                    totalPrice.toFixed(2),
                    " ",
                    currency))))));
};
export default WhatsAppOrderMessage;
